import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=07a95736&scoped=true&lang=pug&"
import script from "./CurrentUser.vue?vue&type=script&lang=js&"
export * from "./CurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&id=07a95736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a95736",
  null
  
)

export default component.exports